'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_timers_package$() {
}
export { $c_sjs_js_timers_package$ as $c_sjs_js_timers_package$ };
$p = $c_sjs_js_timers_package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
export { $h_sjs_js_timers_package$ as $h_sjs_js_timers_package$ };
$h_sjs_js_timers_package$.prototype = $p;
$p.XA = (function(interval, body) {
  return setTimeout((() => {
    body.h();
  }), interval);
});
var $d_sjs_js_timers_package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  vY: 1
}));
export { $d_sjs_js_timers_package$ as $d_sjs_js_timers_package$ };
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
export { $m_sjs_js_timers_package$ as $m_sjs_js_timers_package$ };
